import { cn } from '../../lib/cn'

interface BrassRuleProps {
  /** Clips the rule to a 44px stub — the pillar/section-head treatment. */
  short?: boolean
  className?: string
}

/**
 * The club's section divider: two brass hairlines, the lower at half strength.
 * Drawn by `.club-rule` in fireside.css (a border can't express two rules, and
 * this recurs on every page).
 *
 * Decorative by definition — a divider carries no information a screen reader
 * needs, and the headings around it already convey the structure.
 */
export function BrassRule({ short = false, className }: BrassRuleProps) {
  return (
    <div
      aria-hidden="true"
      className={cn('club-rule', short && 'club-rule-short', className)}
    />
  )
}
